import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "../styles/MenSchemes.css";

const MenScheme = () => {
  const [schemes, setSchemes] = useState([]);

  useEffect(() => {
    const fetchMenSchemes = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "men_schemes"));
        const fetchedSchemes = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("🔥 Fetched Men Schemes:", fetchedSchemes);
        setSchemes(fetchedSchemes);
      } catch (error) {
        console.error("Error fetching men's schemes:", error);
      }
    };

    fetchMenSchemes();
  }, []);

  return (
    <div className="men-schemes-container">
      <h2>Government Schemes for Men</h2>
      {schemes.length === 0 ? (
        <p>No schemes available.</p>
      ) : (
        <ul>
          {schemes.map((scheme) => (
            <li key={scheme.id} className="scheme-card">
              <h3>{scheme.name || "No Name Available"}</h3>
              <p>{scheme.description || "No description available."}</p>
              <p><strong>Documents Required:</strong> {scheme.documents || "Not specified."}</p>
              <p><strong>Valid Time Period:</strong> {scheme.validTime || "No time period specified."}</p>
              <p><strong>State Availability:</strong> {scheme.StateAvailability || "Not mentioned."}</p>
              <p><strong>Hospitality:</strong> {scheme.Hospitality || "Not applicable."}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MenScheme;
